"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var notificationsStore = _interopRequireWildcard(require("../store/userInterfaceNotifications"));

var _UserInterfaceNotifications = _interopRequireDefault(require("../components/UserInterfaceNotifications"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var mapState = function mapState(state) {
  return {
    notificationData: notificationsStore.selectors.getNotifications(state)
  };
};

var mapDispatch = function mapDispatch(dispatch) {
  return {
    removeNotification: function removeNotification(payload) {
      return dispatch(notificationsStore.actions.removeNotification(payload));
    }
  };
};

var UserInterfaceNotifications = function UserInterfaceNotifications(_ref) {
  var connect = _ref.connect;
  var Component = connect(mapState, mapDispatch)(_UserInterfaceNotifications["default"]);
  return /*#__PURE__*/_react["default"].createElement(Component, null);
};

var _default = UserInterfaceNotifications;
exports["default"] = _default;